module.exports = __webpack_public_path__ + "img/palmar-pool-4.1fb7d695.jpg";